import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';

import getImageStyle from 'utils/getImageStyle';

import MediaItem from 'admin-moderator/components/MediaItem';

import Figure from './Figure';
import MaterialListItemStyled from './MaterialListItemStyled';
import Title from './Title';
import Overlay from './Overlay';
import MediaItemWrapper from './MediaItemWrapper';

export class MaterialListItem extends React.PureComponent {
  state = {
    hasImage: false,
  }

  componentDidMount() {
    if (!this.src) return;

    const image = new Image();
    image.onload = () => this.setState({ hasImage: true });
    image.src = this.src;
  }

  get src() {
    return this.props.cover ? getImageStyle(this.props.cover, '144x88') : '';
  }

  render() {
    return (
      <li>
        <MaterialListItemStyled to={`/materials/${this.props.id}`}>
          <Figure>
            <MediaItemWrapper>
              <MediaItem
                cover={this.state.hasImage ? this.src : ''}
                mediaType={this.props.mediaType}
              />

              <Overlay />
            </MediaItemWrapper>

            <Title>{this.props.title}</Title>
          </Figure>
        </MaterialListItemStyled>
      </li>
    );
  }
}

MaterialListItem.propTypes = {
  id: PropTypes.string.isRequired,
  cover: PropTypes.string,
  title: PropTypes.string,
  mediaType: PropTypes.oneOf(['video', 'image']),
};

MaterialListItem.defaultProps = {
  cover: '',
  title: 'Название отсутствует',
  mediaType: 'image',
};

export default withRouter(MaterialListItem);
